// Real Savi Coliving images
export const SAVI_IMAGES = {
  // Villa & Property
  villaAerial: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/f53kgw9p_WhatsApp%20Image%202025-11-25%20at%2008.43.19.jpeg",
  villaEntrance: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/xzwjlru2_WhatsApp%20Image%202025-11-25%20at%2008.42.57.jpeg",
  
  // Community moments
  breakfast: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/jid6lic4_20251008_091716-EDIT.jpg",
  communityCircle: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/bs4v1aa7_20251014_162605%280%29-EDIT%20%281%29.jpg",
  poolside: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/lm1ea386_WhatsApp%20Image%202025-12-19%20at%2010.27.07.jpeg",
  lounging: "https://customer-assets.emergentagent.com/job_savi-guest-portal/artifacts/7cd6k39o_20251016_085400~2.jpg",
};

// Gallery array for easy mapping - Buildings first
export const SAVI_GALLERY = [
  { 
    src: SAVI_IMAGES.villaAerial, 
    title: "Villa Savi", 
    desc: "Your home in the mountains" 
  },
  { 
    src: SAVI_IMAGES.villaEntrance, 
    title: "Welcome Home", 
    desc: "Where your journey begins" 
  },
  { 
    src: SAVI_IMAGES.breakfast, 
    title: "Morning Vibes", 
    desc: "Coffee, conversations & good company" 
  },
  { 
    src: SAVI_IMAGES.communityCircle, 
    title: "Community Circle", 
    desc: "Where connections happen naturally" 
  },
  { 
    src: SAVI_IMAGES.poolside, 
    title: "Poolside Moments", 
    desc: "Sun, water & good times" 
  },
  { 
    src: SAVI_IMAGES.lounging, 
    title: "Slow Living", 
    desc: "Mountain views & peaceful afternoons" 
  },
];

// Social media links
export const SAVI_SOCIAL = {
  instagram: "https://www.instagram.com/savicoliving/",
  facebook: "https://www.facebook.com/people/Savi-Coliving/61577166869338/",
  whatsapp: "https://wa.me/34632628051",
  tiktok: "https://www.tiktok.com/@savicoliving",
  youtube: "https://www.youtube.com/@savicoliving",
  email: "hola@savicoliving.com",
  phone: "+34 632 628 051"
};
